<template>
  <el-dialog :title="$t('ocean-bi::sc-analysis::edit-returnRate')" width="500px" :visible.sync="visible">
    <el-form :model="form" label-width="55px">
      <el-form-item :label="$t('ocean-bi::sc-analysis::退货率')">
        <el-input v-model="form.rate" :placeholder="$t('ocean-bi::sc-analysis::returnRate-holder')"></el-input>
      </el-form-item>
      <p class="tips">{{$t('ocean-bi::sc-analysis::returnRate-tips')}}</p>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">{{$t('system::common::btn::cancel')}}</el-button>
      <el-button type="primary" @click="submit">{{$t('system::common::btn::confirm')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      form: {
        rate: ''
      }
    }
  },
  props: {
    value: {},
    rate: {}
  },
  methods: {
    submit() {
      this.$emit('save', this.form.rate)
      this.visible = false
    }
  },
  watch: {
    value(val) {
      this.visible = val
      if (val) {
        this.form.rate = this.rate
      }
    },
    visible(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped></style>
